import React from "react";
import * as utility from "../../../utilities/utils";
import { ServiceApi } from "../../../environment";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

function NonFusionFooter(props) {
  let prodType = utility.getPartner();
  let utilityLabel1 = utility.findUtilityLabelFromProductForFooter(prodType, utility.getQString());

  return (
    <>
      <ul className="list-inline mastfoot-links mb-0">
        <li className="list-inline-item"> <a href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer1Href))}
          title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer1Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer1Title))}>
          {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer1Title))}</a></li>
          <li class="list-inline-item divider">|</li>
        <li className="list-inline-item">
          <a href={utility.getQString() === "en" ? ServiceApi.FOOTER_ENG_URL : ServiceApi.FOOTER_SPN_URL}
            title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer14Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer14Title))}>
            {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer14Title))}</a>
        </li>
        <li class="list-inline-item divider">|</li>
        <li className="list-inline-item">
          <a  href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer2Href))}
            title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer2Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer2Title))}>
            {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer2Title))}</a>
        </li>
        <li class="list-inline-item divider">|</li>
        <li className="list-inline-item">
          <a href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer3Href))}
            title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer3Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer3Title))}>
            {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer3Title))}</a>
        </li>
        <li class="list-inline-item divider">|</li>
        <li className="list-inline-item">
          <a href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer5Href))}
            title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer5Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer5Title))}>
            {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer5Title))}</a>
        </li>
        <li class="list-inline-item divider">|</li>
        <li className="list-inline-item">
          <a href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer6Href))}
            title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer6Title))} tabIndex="-1"
            aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer6Title))}>{parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer6Title))}</a>
        </li>
        <li class="list-inline-item divider">|</li>
        <li className="list-inline-item">
          <a href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer7Href))}
            title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer7Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer7Title))}>
            {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer7Title))}</a>
        </li>

        <li className="list-inline-item">
          <a href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer9Href))}
            title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer9Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer9Title))}>
            {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer9Title))}</a></li>
            <li class="list-inline-item divider">|</li>
         <li className="list-inline-item"><a href={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer10Href))} title={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer10Title))} tabIndex="-1" aria-label={parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer10Title))}>
          {parse(DOMPurify.sanitize(utilityLabel1.utilityLabel.footer10Title))}</a></li></ul>


    </>
  );

}

export default NonFusionFooter;